import { Avatar, Button, ButtonGroup, Fab, Modal, Stack, styled, TextField, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import AddIcon from '@mui/icons-material/Add';
import { Box } from "@mui/system";
import { EmojiEmotions, Image, PersonAdd, VideoCameraBack } from "@mui/icons-material";
const Add = () =>{

    const [ open, setOpen] = useState(false);

    const StyledModel = styled(Modal)({
        display:"flex",
        alignItems:"center",
        justifyContent:"center"
    })
    const UserBox = styled(Box)({
        display:"flex",
        alignItems:"center",
        gap:"10px",
        marginBottom:"20px"
        // justifyContent:"center"
    })
    return(
        <>
            <Tooltip title="Add" 
            sx={{
                position:"fixed", 
                bottom:20,
                left: {xs:"calc(50% - 25px)", md: 30}
            }}
            >
                <Fab color="primary" aria-label="add">
                    <AddIcon onClick={(e)=>setOpen(true)} />
                </Fab>
            </Tooltip>

            <StyledModel
                open={open}
                onClose={(e)=>setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                >
                <Box width={400} height={300} bgcolor="white" p={3} borderRadius={5}>
                    <Typography variant="h6" color="gray" textAlign="center">Create Post</Typography>
                    <UserBox>
                        <Avatar
                        src="http://material-ui.com/static/images/avatar/1.jpg"
                        sx={{width:30, height:30}}
                        />
                        <Typography fontWeight={500} variant="span">Muhammad Kamran</Typography>
                    </UserBox>
                    <TextField
                        sx={{width:"100%"}}
                        id="standard-multiline-static"
                        multiline
                        rows={3}
                        placeholder="What's on your mind?"
                        variant="standard"
                    />
                    <Stack direction="row" gap={1} mt={2} mb={3}>
                        <EmojiEmotions color="primary"/>
                        <Image color="secondary"/>
                        <VideoCameraBack color="success"/>
                        <PersonAdd color="error"/>
                    </Stack>
                    <ButtonGroup fullWidth variant="contained" aria-label="outlined primary button group">
      <Button>Post</Button>
      {/* <Button>Two</Button>
      <Button>Three</Button> */}
    </ButtonGroup>
                </Box>
            </StyledModel>
        </>
    );
}

export default Add;